export default __webpack_public_path__ + "static/media/Homework_16_9.9fc50f18.png";